import { useEffect, useRef, useState } from "react";
import { motion, useInView, useMotionValue, animate } from "framer-motion";

export const Counter = ({ to = 100, suffix = "", duration = 1.6, decimals = 0 }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-40px" });
    const [val, setVal] = useState(0);
    const mv = useMotionValue(0);

    useEffect(() => {
        if (!isInView) return;
        const controls = animate(mv, to, {
            duration,
            ease: [0.16, 1, 0.3, 1],
            onUpdate: (v) => setVal(v),
        });
        return () => controls.stop();
    }, [isInView, to, duration, mv]);

    return (
        <span ref={ref}>
            {val.toFixed(decimals)}
            {suffix}
        </span>
    );
};

export const RevealStat = ({ value, label, suffix = "", decimals = 0 }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="border-r border-b border-[#dddddd] p-8 md:p-12 bg-white"
        >
            <p className="font-serif text-5xl md:text-7xl text-[#111111] leading-none">
                <Counter to={value} suffix={suffix} decimals={decimals} />
            </p>
            <p className="mt-5 text-[10px] tracking-[0.28em] uppercase text-[#444444]">
                {label}
            </p>
        </motion.div>
    );
};
